<template>
  <div class="relative flex items-center justify-center p-16">
    <video
      ref="main"
      src="@/assets/videos/CPN_Escent_Condo_Hatyai_Animation.mp4"
      poster="@/assets/videos/CPN_Escent_Condo_Hatyai_Animation.jpg"
      class="relative w-full max-w-screen-xl rounded-sm shadow-2xl"
      width="1920"
      height="1080"
      autoplay
      controls
      controlsList="nodownload"
      loop
    />
  </div>
</template>

<script>
export default {
  name: 'Animation',
  activated () {
    this.$refs.main.play()
  },
}
</script>
